import API from './API';
import OpportunityActions from 'actions/OpportunityActions';
import URLSearchParams from 'url-search-params';

const OpportunitySource = {
  getRemoteOpportunityList: {
    remote(state) {
      let sendData = {
        first: state.first,
        maxCount: state.maxCount
      };
      let searchParams = new URLSearchParams();
      for(let k in sendData) {
        if(sendData[k] === 0 || sendData[k]) {
          searchParams.append(k, sendData[k]);
        }
      }
      let param = {
          method: 'POST',
          body: JSON.stringify(sendData),
          headers: API.jsonHeader
      };
      return fetch(`${API.getOpportunityList}?${searchParams}`,param).then(res=>res.json()).then(json=>{
        json.updateFnName = 'updateOpportunityList';
        return json;
      });
    },
    shouldFetch() {
      return true;
    },
    success: OpportunityActions.fetchSuccess,
    error: OpportunityActions.fetchFailed
  },
  getRemoteOpportunity: {
    remote(state) {
      let url = API.getOpportunityDetail.replace(':id', state.id);
      return fetch(url).then(res=>res.json()).then(json=>{
        json.updateFnName = 'updateOpportunity';
        return json;
      });
    },
    shouldFetch(state) {
      if(state.id) {
        return true;
      }
    },
    success: OpportunityActions.fetchSuccess,
    error: OpportunityActions.fetchFailed
  },
  getRemoteOpportunityRegister: {
    remote(state) {
      let sendData = {
        first: state.first,
        maxCount: state.maxCount
      };
      let searchParams = new URLSearchParams();
      for(let k in sendData) {
        if(sendData[k] === 0 || sendData[k]) {
          searchParams.append(k, sendData[k]);
        }
      }
      let url = API.getOpportunityRegister.replace(':id', state.id);
      return fetch(`${url}&${searchParams}`).then(res=>res.json()).then(json=>{
        json.updateFnName = 'updateOpportunityRegister';
        return json;
      });
    },
    shouldFetch(state){
      if(state.id){
        return true;
      }
    },
    success: OpportunityActions.fetchSuccess,
    error: OpportunityActions.fetchFailed
  },
  getRemoteOpportunitySelecter: {
    remote(state) {
      let sendData = {
        first: state.first,
        maxCount: state.maxCount
      };
      let searchParams = new URLSearchParams();
      for(let k in sendData) {
        if(sendData[k] === 0 || sendData[k]) {
          searchParams.append(k, sendData[k]);
        }
      }
      let url = API.getOpportunitySelecter.replace(':id', state.id);
      return fetch(`${url}&${searchParams}`).then(res=>res.json()).then(json=>{
        json.updateFnName = 'updateOpportunitySelecter';
        return json;
      });
    },
    shouldFetch(state){
      if(state.id){
        return true;
      }
    },
    // loading: SearchActions.loadingResults, // (optional)
    success: OpportunityActions.fetchSuccess,
    error: OpportunityActions.fetchFailed
  }
};

export default OpportunitySource;


// WEBPACK FOOTER //
// ./src/sources/OpportunitySource.js